module.exports = __webpack_public_path__ + "img/m_2.f241cfb1.png";